import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { IAssetStorageEntry } from '../asset-storage-entry';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { AssetSettingsService } from '../../asset-settings/asset-settings.service';
import { AssetStorageDirectoryPermissionDTO, AssetStoragePermissionGroupDTO, Role, UpdateAssetStorageDirectoryPermissionsDTO } from 'src/app/base/models/models.swagger.generated';
import { AssetStorageService } from '../asset-storage.service';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { AuthService } from 'src/app/base/services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-asset-storage-directory-permission',
    templateUrl: './asset-storage-directory-permission.component.html',
    styleUrls: ['./asset-storage-directory-permission.component.scss'],
    imports: [DialogModule, GridModule, QueryBuilderModule, ReactiveFormsModule, FormsModule, TranslateModule, CommonModule],
    providers: [AssetSettingsService]
})
export class AssetStorageDirectoryPermissionComponent implements OnInit{

  @ViewChild('directoryPermissionsDialog') private directoryPermissionsDialog: DialogComponent;
  @Output()
  public directoryPermissionsChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  public isSaveDisabled: boolean = true;
  public directoryEntry: IAssetStorageEntry;
  public allMergdeDirectoryPermissions: AssetStorageDirectoryPermissionDTO[] = [];
  public changedDirectoryPermissions: AssetStorageDirectoryPermissionDTO[] = [];
  public isLimitedAdmin: boolean = false;
  private allGroups: AssetStoragePermissionGroupDTO[];

  public customEditSettings = {
    allowEditing: false,
    allowAdding: false,
  };

  constructor(private assetSettingsService: AssetSettingsService,
    private assetStorageService: AssetStorageService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef)
  {
  }

  ngOnInit(): void {
    this.isLimitedAdmin = this.authService.doesUserHaveAnyRole([Role.AssetStorageLimitedAdmin])
  }

  public onCancel() {
    this.directoryPermissionsDialog.hide();
  }

  public onSave() {
    // prepare UpdateAssetStoragePermissionGroupDTO
    var dto = {
      directoryId: this.directoryEntry.entryId,
      directoryPermissions: this.changedDirectoryPermissions
    } as UpdateAssetStorageDirectoryPermissionsDTO;
    this.assetStorageService.updateDirectoryPermissions(dto).subscribe(() => {
      this.directoryPermissionsChange.emit();
      this.directoryPermissionsDialog.hide();
    });
  }

  public getGroupName(groupId: number): string {
    const group = this.allGroups.find((g) => g.id === groupId);
    return group ? group.name : '';
  }

  public permissionChange(args: any, data: AssetStorageDirectoryPermissionDTO, permission: string) {
    const originalData = this.allMergdeDirectoryPermissions.find(dp => dp.groupId === data.groupId);
    const changedData = this.changedDirectoryPermissions.find(dp => dp.groupId === data.groupId) || data;
    if (permission === 'read') {
      changedData.read = data.read;
    }
    if (permission === 'write' && !this.isLimitedAdmin) {
      changedData.write = data.write;
    }
    const permissionChanged = originalData.read !== changedData.read || originalData.write !== changedData.write;

    if (!permissionChanged) {
      this.changedDirectoryPermissions = this.changedDirectoryPermissions.filter(dp => dp.groupId !== data.groupId);
    } else {
      if (!this.changedDirectoryPermissions.includes(changedData)) {
        this.changedDirectoryPermissions.push(changedData);
      }
    }

    this.isSaveDisabled = this.changedDirectoryPermissions.length === 0;
  }

  public openDirectoryPermissions(asset: IAssetStorageEntry) {
    this.directoryEntry = asset;
    this.isSaveDisabled = true;

    this.assetSettingsService.getAllPermissionGroups().subscribe((groups) => {
      // Initialize the merged permissions array
      this.allMergdeDirectoryPermissions = [];
      this.changedDirectoryPermissions = [];
      this.allGroups = groups;

      // Iterate over each group
      groups.forEach((group) => {
        // Check if the current group has permissions for this directory
        const directoryPermission = this.directoryEntry.directoryPermissions?.find((dp) => dp.groupId === group.id);

        // Create a new permission object
        const permission = {
          id: directoryPermission ? directoryPermission.id : 0,
          directoryId: this.directoryEntry.entryId,
          groupId: group.id,
          read: directoryPermission ? directoryPermission.read : false,
          write: directoryPermission ? directoryPermission.write : false
        } as AssetStorageDirectoryPermissionDTO;

        // Add the new permission object to the merged permissions array
        this.allMergdeDirectoryPermissions.push(permission);
      });

      // Show the directory permissions dialog
      this.directoryPermissionsDialog.show();
      this.cdr.detectChanges();
    });
  }
}
